import { observable } from "mobx"
import { StudentResults } from "../../../react/students/StudentResults"
import { StudentResultsStore } from "../../../react/students/StudentResultsStore"
import { MakeVaperAgreement } from "./part-2/MakeYourOwnVaperPartTwoTypes"
import { MakeVaperChoices, MakeVaperPart } from "./types/MakeYourOwnVaperTypes"

export class MakeVaperPartsStore {

    private static innerInstance: MakeVaperPartsStore

    @observable
    spud: MakeVaperChoices = {}

    private agree: MakeVaperAgreement

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    static newInstance() {
        return this.innerInstance = new this()
    }

    static getCurrentStudentSpud = () => StudentResultsStore.instance.currentStudentResults.makeYourOwnVaperChoices

    get agreement(): MakeVaperAgreement {
        return this.agree
    }

    set agreement(agreement: MakeVaperAgreement) {
        this.agree = agreement
    }

    addPart = (part: MakeVaperPart, isTrait: boolean) => {
        switch (part) {
            case MakeVaperPart.SMART:
                this.spud.smart = isTrait
                break
            case MakeVaperPart.COOL:
                this.spud.cool = isTrait
                break
            case MakeVaperPart.POPULAR:
                this.spud.popular = isTrait
                break
            case MakeVaperPart.EXCITING:
                this.spud.exciting = isTrait
                break
            case MakeVaperPart.ATHLETIC:
                this.spud.athletic = isTrait
                break
            default:
                throw new Error("Vaper part not recognized.")
        }
    }

    saveToFirestore = () => {
        const update: Partial<StudentResults> = {
            makeYourOwnVaperChoices: this.spud
        }
        StudentResultsStore.instance.update(update)
    }
}
